/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PageProps } from "../../../models/PageProps";
import { getGeneralError } from "../../../util/helperFunctions";
import { Loader } from "../../../components/Loader";
import AlertBox from "../../../components/AlertBox";
import ClinicProfileApi from "../../../api/ClinicProfileApi";
import { getAccessToken } from "../../../util/LocalStorageVariables";
import { ClinicProfileResponse } from "../../../models/clinic/profile/ClinicProfileResponse";
import ClinicProfile from "./ClinicProfile";

const ClinicProfilePage: React.FC<PageProps> = ({ setPageLoading }: PageProps) => {
  const [profile, setProfile] = useState<ClinicProfileResponse>();
  const [error, setError] = useState<string | null>(null);
  const { clinicId } = useParams<"clinicId">();

  useEffect(() => {
    const getProfile = async (id: string) => {
      try {
        let response;
        if (getAccessToken()) {
          response = await ClinicProfileApi.getClinicProfile(id);
        } else {
          response = await ClinicProfileApi.getPublicClinicProfile(id);
        }
        setProfile(response.data);
      } catch (e) {
        setError(await getGeneralError(e));
      } finally {
        setPageLoading(false);
      }
    };

    if (clinicId) {
      void getProfile(clinicId);
    }
  }, [clinicId]);

  if (error) {
    return <AlertBox message={error} />;
  }

  if (!profile) {
    return <></>;
  }

  return (
    <main className="main-signed-in">
      <section>
        <div className="px-4 lg:px-6 py-6 space-y-6">
          <ClinicProfile profile={profile} />
        </div>
      </section>
    </main>
  );
};

export default Loader(ClinicProfilePage);
